import { Pipe, PipeTransform } from '@angular/core';
import { AudienceFilterApp, AudienceFilterOperator, AudienceFilterType } from 'app/audience/components/audience.model';
import { filter } from 'rxjs/operators';

@Pipe({
  name: 'audienceFilterOperator',
  standalone: false,
})
export class AudienceFilterOperatorPipe implements PipeTransform {
  transform(operator: string, filterConfig): unknown {
    const op = operator.slice(operator.lastIndexOf('.') + 1);
    if (filterConfig.app === AudienceFilterApp.Custobar) {
      if (filterConfig.type === AudienceFilterType.AppTags) {
        if (op === AudienceFilterOperator.Equals) {
          return AudienceFilterOperator.HaveTag;
        } else if (op === AudienceFilterOperator.NotEquals) {
          return AudienceFilterOperator.NotHaveTag;
        }
      }
    } else if (filterConfig.app === AudienceFilterApp.Klaviyo || filterConfig.app === AudienceFilterApp.Shopify) {
      if (filterConfig.type === AudienceFilterType.AppSegment) {
        if (op === AudienceFilterOperator.Equals) {
          return AudienceFilterOperator.PartOf;
        } else if (op === AudienceFilterOperator.NotEquals) {
          return AudienceFilterOperator.NotPartOf;
        }
      }
    } else if (
      filterConfig.app === AudienceFilterApp.Mailchimp ||
      filterConfig.app === AudienceFilterApp.Rule ||
      filterConfig.app === AudienceFilterApp.Brevo ||
      filterConfig.app === AudienceFilterApp.Dotdigital ||
      filterConfig.app === AudienceFilterApp.CleverReach ||
      filterConfig.app === AudienceFilterApp.Omnisend
    ) {
      if (op === AudienceFilterOperator.Equals) {
        return AudienceFilterOperator.PartOf;
      } else if (op === AudienceFilterOperator.NotEquals) {
        return AudienceFilterOperator.NotPartOf;
      }
    } else if (filterConfig.app === AudienceFilterApp.Voyado) {
      if (op === AudienceFilterOperator.Equals) {
        if (filterConfig.type === AudienceFilterType.AppSegment) {
          return AudienceFilterOperator.PartOf;
        } else if (filterConfig.type === AudienceFilterType.AppLabels) {
          return AudienceFilterOperator.Have;
        }
      } else if (op === AudienceFilterOperator.NotEquals) {
        if (filterConfig.type === AudienceFilterType.AppSegment) {
          return AudienceFilterOperator.NotPartOf;
        } else if (filterConfig.type === AudienceFilterType.AppLabels) {
          return AudienceFilterOperator.DoNotHave;
        }
      }
    } else if (filterConfig.type === AudienceFilterType.Goals || AudienceFilterType.Purchase) {
      if (op === AudienceFilterOperator.Equals) {
        return AudienceFilterOperator.Have;
      } else if (op === AudienceFilterOperator.NotEquals) {
        return AudienceFilterOperator.HaveNot;
      }
    }

    if (
      filterConfig.app === AudienceFilterApp.MailerLite ||
      filterConfig.app === AudienceFilterApp.Emarsys ||
      filterConfig.app === AudienceFilterApp.Klaviyo
    ) {
      if (filterConfig.type === AudienceFilterType.AppList) {
        if (op === AudienceFilterOperator.Equals) {
          return AudienceFilterOperator.PartOf;
        } else if (op === AudienceFilterOperator.NotEquals) {
          return AudienceFilterOperator.NotPartOf;
        }
      }
    }
    return operator;
  }
}
